import { Component, Input } from '@angular/core';
import { ItemsComponent } from '@common/classes/items.component.abstract';
import { ColumnSettings } from '@common/interfaces/column-settings.interface';
import { FormProperty } from '../app-control/app-control.component';

@Component({
    selector: 'app-attachments',
    templateUrl: './attachments.component.html'
})
export class AttachmentsComponent extends ItemsComponent<any> {
    @Input() protected override command: string;
    @Input() protected override itemName: string;
    @Input() protected override itemCreatePermission: string;
    @Input() protected override itemEditPermission: string;
    @Input() protected override itemRemovePermission: string;
    @Input() protected override dialogProperties: FormProperty<string>[];
    @Input() override columns: ColumnSettings[];

    override canConfirm?: (model: any) => boolean = (model: any) => model.file;
}
